import { useMutation, useQueryClient } from 'react-query'

import toastService from '../../components/toast/toast-service'
import { QueryKey } from '@/configs/queryKeys'
import { submeterPedido } from '@/services/componente-de-credito'

interface IComponenteDeCreditoParams {
  idPedido: string
  idUsuario: string
  nomeUsuario: string
}

export function useComponenteDeCreditoMutation() {
  const queryClient = useQueryClient()

  const mutationFn = (vars: IComponenteDeCreditoParams) =>
    submeterPedido({
      queryKey: [
        'submeterPedido',
        {
          params: {
            idPedido: vars.idPedido,
            idUsuario: vars.idUsuario,
            nomeUsuario: vars.nomeUsuario
          }
        }
      ]
    } as any)

  return useMutation(mutationFn, {
    onSuccess: async () => {
      queryClient.invalidateQueries(QueryKey.pedidosPendentesList)
      queryClient.invalidateQueries(QueryKey.pedidosListItems)
    },
    onError: async (error: any) => {
      toastService.error(error)
    }
  })
}